<template>
  <v-layout column>
    <ums-user-info-view
      :loading-error="loadingError"
      :loading="isLoading"
      :user="user"
      @change:success="refreshUserData"
    />

    <ums-user-history-list ref="userHistoryList" />

    <ums-user-roles-list
      :loading-error="loadingError"
      :roles="user.roles || []"
      :loading="isLoading"
      :email="user.email"
      @change:success="refreshUserData"
    />

    <ums-user-barcodes-list
      :loading-error="loadingError"
      :barcodes="user.barcodes || []"
      :loading="isLoading"
      @change:success="refreshUserData"
      @refresh="refreshUserData"
    />
  </v-layout>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import { useDataLoading } from '@mixins/factories';

import { namespace as UsersNamespace, ActionTypes as UsersActionTypes } from '../store.types';

import UmsUserInfoView from '../_components/UmsUserInfoView.vue';
import UmsUserHistoryList from '../_components/UmsUserHistoryList.vue';
import UmsUserRolesList from '../_components/UmsUserRolesList.vue';
import UmsUserBarcodesList from '../_components/UmsUserBarcodesList.vue';

const dataLoadingOptions = {
  getterName: UsersActionTypes.GET_USER,
  ignoredQueryItems: ['pageNum'],
  parameterize: true,
  searchable: false,
  paged: false,
};

export default {
  name: 'UmsUser',
  components: {
    UmsUserInfoView,
    UmsUserHistoryList,
    UmsUserRolesList,
    UmsUserBarcodesList,
  },
  mixins: [
    useDataLoading(dataLoadingOptions),
  ],
  computed: {
    ...mapState(UsersNamespace, ['user']),
  },
  methods: {
    ...mapActions(UsersNamespace, [UsersActionTypes.GET_USER]),
    refreshUserData() {
      this.$_fetchData();
      this.$refs.userHistoryList.$_refreshData();
    },
  },
};
</script>
